import { ROUTE_RISK_ANALYSIS } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './risk-analysis.page';

export const routeRiskAnalysis: RouteObject = {
  path: ROUTE_RISK_ANALYSIS,
  Component: Page,
  loader: setTitleFromLoader('Risk Analysis'),
};
